import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import theme from '../../../theme';
import trackColors from '../../../utils/gaia/trackColors';
import OutlinedSelect, {OutlinedSelectProps} from '../OutlinedSelect';
import {makeStyles} from '@material-ui/core/styles';

const useColorSelectClasses = makeStyles({
    iconOutlined: {
        right: 1
    }
});

export default function ColorSelect(props: Partial<OutlinedSelectProps>) {
    const colorSelectClasses = useColorSelectClasses();

    return <OutlinedSelect
        label="Color"
        style={{minWidth: '50px', marginTop: theme.spacing(1)}}
        classes={{iconOutlined: colorSelectClasses.iconOutlined}}
        renderValue={value => {
            return (
                <div
                    style={{
                        position: 'relative',
                        height: theme.spacing(3),
                        width: theme.spacing(3),
                        backgroundColor: value as string,
                        borderRadius: theme.shape.borderRadius,
                    }}
                />
            );
        }}
        SelectDisplayProps={{
            style: {
                borderRadius: theme.shape.borderRadius,
                paddingBottom: 6,
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(2.5),
                paddingTop: 6,
            },
        }}
        MenuProps={{
            transitionDuration: 100,
            MenuListProps: {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: (15 + theme.spacing(2)) * 7,
                    flexGrow: 1,
                    justifyContent: 'center',
                }
            }
        }}
        {...props}
    >
        {trackColors.map((color: string) => (
            <MenuItem
                style={{paddingLeft: theme.spacing(1), paddingRight: theme.spacing(1)}}
                key={color}
                value={color}
                title={color}
            >
                <div
                    style={{
                        position: 'relative',
                        height: theme.spacing(3),
                        width: theme.spacing(3),
                        backgroundColor: color,
                        borderRadius: theme.shape.borderRadius,
                    }}
                />
            </MenuItem>
        ))}
    </OutlinedSelect>;
}
